import { render, staticRenderFns } from "./FormValidationPlaceholderArguments.vue?vue&type=template&id=0b4c3915&"
import script from "./FormValidationPlaceholderArguments.vue?vue&type=script&lang=js&"
export * from "./FormValidationPlaceholderArguments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports